import { z } from "zod";

// User Profile validation schema
export const userProfileSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  workEmail: z.string().email("Invalid email address"),
  jobTitle: z
    .string()
    .max(255, "Job title must be 255 characters or less")
    .nullable()
    .optional()
    .or(z.literal("")),
});

// Trade Revenue validation schema
export const tradeRevenueSchema = z.object({
  asiRevenue: z.number().int().min(0).max(100000000).nullable().optional(),
  esiRevenue: z.number().int().min(0).max(100000000).nullable().optional(),
  psiRevenue: z.number().int().min(0).max(100000000).nullable().optional(),
  rsiRevenue: z.number().int().min(0).max(100000000).nullable().optional(),
});

// Type inference
export type UserProfileFormData = z.infer<typeof userProfileSchema>;
export type TradeRevenueFormData = z.infer<typeof tradeRevenueSchema>;
